import { render, staticRenderFns } from "./SafeCulture.vue?vue&type=template&id=060df72a&scoped=true&"
import script from "./SafeCulture.vue?vue&type=script&lang=js&"
export * from "./SafeCulture.vue?vue&type=script&lang=js&"
import style0 from "./SafeCulture.vue?vue&type=style&index=0&id=060df72a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060df72a",
  null
  
)

export default component.exports